import React from 'react'
import Layout from '../../common/Layout'
import VerifyEmailAddressContainer from '../../features/VerifyEmailAddress/VerifyEmailAddressContainer'

export default {
  path: '/verify/:token',
  async action ({ params }) {
    const token = params.token
    return {
      title: 'Verify Email Address',
      component: <Layout containerWell ><VerifyEmailAddressContainer token={token} /></Layout>
    }
  }

}
